import { render, staticRenderFns } from "./WebWorkflowAntragUest.vue?vue&type=template&id=05be0186&scoped=true"
import script from "./WebWorkflowAntragUest.vue?vue&type=script&lang=ts"
export * from "./WebWorkflowAntragUest.vue?vue&type=script&lang=ts"
import style0 from "./WebWorkflowAntragUest.vue?vue&type=style&index=0&id=05be0186&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05be0186",
  null
  
)

export default component.exports